import React from 'react';
import './Aboutus.css';
import "bootstrap/dist/css/bootstrap.min.css";
import 'bootstrap-icons/font/bootstrap-icons.css';
// eslint-disable-next-line
import i18n from "../../i18n";
import { useTranslation } from 'react-i18next';


const Aboutus = () => {
    const { t, i18n } = useTranslation();

    return (
        <section id="about" className="about">
      <div className="container" data-aos="fade-up" data-aos-duration="800" >

        <div className="section-title">
          <h2>{t('About_Us')}</h2>
          <p>{t('MBrief_overview')}</p>
        </div>

        <div className="row content">
          <div className="col-lg-6">
            <p>{t('JSOURCE_is_a_oftware_company')}</p>
            <ol>
              <li>{t('The_company_has_a_wide')}</li>
              <li>{t('Diversity_in_service')}</li>
              <li>{t('Sincerity_to_work')}</li>
            </ol >
          </div>

          <div className="col-lg-6 pt-lg-0">
            <p>{t('then_the_company_launched')} </p>
            <p>{t('In_conclusion')}</p>
              <p>{t('To_join_our_family')}</p>
            <a href="#contact" className="btn-learn-more">{t('contact_us')}</a>
          </div>
        </div>

      </div>
    </section>
    )
}

export default Aboutus
